<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑分类' : '添加分类'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="所属行业" prop="industry_id">
				<template>
					<el-select v-model="item.industry_id" filterable placeholder="请选择">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</template>
			</el-form-item>
			<el-form-item label="上级分类">
				<el-select v-model="item.parent_id" filterable placeholder="不选择则作为一级分类">
					<el-option v-for="item in optionsParent" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="分类名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入分类名称" class="el-input-default-width-220"></el-input>
			</el-form-item>
			<el-form-item label="排序号" prop="orders">
				<el-input v-model="item.orders" placeholder="请输入排序号" class="el-input-default-width-220"></el-input>
			</el-form-item>
			<el-form-item label="分类图标" prop="logo">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('logo', value)"
						:show-file-list="false"
						:action="app_url + '/admin/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.logo"></i>
					<img :src="item.logo" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {
					logo: '',
					industry_id: '',
					name: '',
					parent_id: ''
				},
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				logo: [],
				optionsParent: [],
				options: [],
				rules: {
					industry_id: [{
						required: true,
						message: '所属行业不存在',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '分类名称不存在',
						trigger: 'blur'
					}, ],
					logo: [{
						required: true,
						message: '分类图标不存在'
					}, ],
				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ''
				res = await this.axios.post('/admin/industry/list', {
					page: this.page,
					limit: this.pageSizeNume
				})
				this.options = res.data.list.data
				res = await this.axios.get('/admin/data/getCategoryTreeAdmin', {})
				this.optionsParent = res.data.list
				if (this.id) {
					res = await this.axios.get('/admin/productCategory/detail', {
						params: {
							id: this.id
						}
					})
					this.item = Object.assign(this.item, res.data.detail)
					// 当图片存在的时候
					this.item.parent_id = this.item.parent_id != 0 ? this.item.parent_id : '';
				} else {
					// 添加操作
					this.item.orders = 1;
				}
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				// 存储图片且刷新 因为上传的和存储的图片不是同一个
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false

				// 父节点ID 树
				let parentType = typeof this.item.parentId
				if (parentType == "object" && parentType != null && parentType != undefined) {
					if (this.item.parentId) {
						var parentId = this.item.parentId.pop()
						this.item.parentId = parentId
					}
				} else if (parentType == "string") {

				} else {
					this.item.parentId = 0
				}

				let url = ''
				if (this.id) {
					url = '/admin/productCategory/update'
					this.item.id = this.id
				} else {
					url = '/admin/productCategory/add'
				}

				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
			},
		}
	}
</script>
<style scoped>
</style>·
